import { DescriptionOutlined as DescriptionIcon } from '@mui/icons-material';

const Description = (): JSX.Element => <DescriptionIcon fontSize="inherit" />;

export default Description;
